import { styled, Typography as _Typography } from '@mui/material';

export const Typography = styled(_Typography)<{ status?: string }>(({ theme, status }) => ({
  color: status === 'INFO_NEEDED' ? theme.palette.warning.main : 'inherit',
  fontSize: 13,
  fontWeight: 500,
  textTransform: 'uppercase',
}));
